import { jsonSchema, type ModelMessage, streamText, tool, type Tool } from 'ai';

import { type Subagent } from './mcpClient';
import { dixaGateway } from './provider';

type SubagentInput = {
  query: string;
};

const inputSchema = jsonSchema<SubagentInput>({
  type: 'object',
  properties: {
    query: {
      type: 'string',
      description: 'Plain-English question for the subagent to answer.',
    },
  },
  required: ['query'],
});

export const createSubagentTool = (subagent: Subagent, chatId: string): Tool =>
  tool({
    description: subagent.description,
    inputSchema,
    execute: async ({ query }, { abortSignal, messages }) => {
      const result = streamText({
        model: dixaGateway(subagent.prompt),
        messages: [
          ...messages,
          { role: 'user', content: query } as ModelMessage,
        ],
        tools: subagent.tools,
        abortSignal,
        headers: { traceparent: `00-${chatId}-4fe7d85c49cf1379-01` },
      });
      return await result.text;
    },
  });
